import { useState, useEffect } from 'react';
import axios from 'axios';

export const useBankAccounts = () => {
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/finance/banks`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setBanks(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  return { banks, loading };
};